import React from "react";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';

import {PricingListBrandDropdown} from "./PricingListBrandDropdown";
import {usePricingsStore} from "../../stores/pricingsStore";
import {useShallow} from "zustand/react/shallow";
import {useDebounce} from "@uidotdev/usehooks";
import useDidMountEffect from "../../hooks/useDidMountEffect";


export const PricingListTableSearchBarHeader = ( { make, headerHeight } ) => {
    const [searchValue, setSearchValue] = React.useState('');
    const {
        search,
        setSearch,
    } = usePricingsStore(
        useShallow((state) => ({
            search: state.search,
            setSearch: state.setSearch,
        }))
    )

    const debouncedSearch = useDebounce(searchValue, 500)

    useDidMountEffect(function setSearchStateInStore(){
        setSearch(debouncedSearch);
    }, [debouncedSearch])


    return (
        <div className={'PricingListTableSearchBarHeader'}>
            <PricingListBrandDropdown make={make}/>
            <div className={'PricingListTableSearchBarHeader_search-container'}>
                <input
                    type="text"
                    value={searchValue}
                    placeholder={'Search'}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
                <button type="button" className={'pricing-search-btn'} aria-label="Search">
                    <SearchIcon/>
                </button>
            </div>
        </div>
    )
}